// Tiny typed DOM helpers shared across views.

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  cls?: string,
  text?: string,
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (cls) node.className = cls;
  if (text !== undefined) node.textContent = text;
  return node;
}

// SVG counterpart of el() - createElementNS, so the node actually renders as SVG.
export function svgEl<K extends keyof SVGElementTagNameMap>(
  tag: K,
  attrs?: Record<string, string>,
): SVGElementTagNameMap[K] {
  const node = document.createElementNS("http://www.w3.org/2000/svg", tag);
  if (attrs) {
    for (const key of Object.keys(attrs)) node.setAttribute(key, attrs[key]);
  }
  return node;
}

export function button(cls: string, label: string, onClick: () => void): HTMLButtonElement {
  const b = el("button", cls);
  b.type = "button";
  b.textContent = label;
  b.addEventListener("click", onClick);
  return b;
}
